import { z } from "zod";

import { LocationData } from "../../../../models/LocationData";

export const schema = z.object({
  openingDate: z.coerce.date().nullish(),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (data: LocationData): Schema => {
  let openInfoData = null;

  if (data.open_info) {
    openInfoData = JSON.parse(data.open_info);
  }

  const openingDate = openInfoData?.openingDate;

  // Convert {year, month, day} to Date object
  if (openingDate?.year && openingDate?.month && openingDate?.day) {
    return {
      openingDate: new Date(
        openingDate.year,
        openingDate.month - 1,
        openingDate.day
      ),
    };
  }

  return {
    openingDate: undefined,
  };
};
